import { render, staticRenderFns } from "./ManageLocationModal.vue?vue&type=template&id=4e227606&scoped=true&"
import script from "./ManageLocationModal.vue?vue&type=script&lang=js&"
export * from "./ManageLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e227606",
  null
  
)

export default component.exports